import { useState, useEffect } from "react";

const getOrientation = () => {
  if (window.innerHeight > window.innerWidth) return "portrait";

  return "landscape";
};

function useScreenOrientation() {
  const [orientation, setOrientation] = useState(getOrientation());

  const enableCanvasPointerEvent = () => {
    const canvas = document.getElementById("full-screenable-node");
    canvas.style.pointerEvents = "auto";
  };

  const disableCanvasPointerEvent = () => {
    if(window.innerWidth > 950) return;
    
    const canvas = document.getElementById("full-screenable-node");
    canvas.style.pointerEvents = "none";
  };

  const updateOrientation = () => {
    setOrientation(getOrientation());

    if (orientation === "landscape") disableCanvasPointerEvent();

    if (orientation === "portrait") enableCanvasPointerEvent();
  };

  useEffect(() => {
    const orientation = getOrientation();
    if (orientation === "portrait") disableCanvasPointerEvent();
  });

  useEffect(() => {
    window.addEventListener("resize", updateOrientation);

    return () => {
      window.removeEventListener("resize", updateOrientation);
    };
  }, [updateOrientation]);

  return orientation;
}

export default useScreenOrientation;
